import { jsx as _jsx } from "react/jsx-runtime";
import { CanvasLayerScope } from '../../../r3f/canvasLayerScope';
export function ParallaxBackgroundCanvasScope({ solveNode, children }) {
    // painter-view-exempt: `ParallaxBackgroundProperties` is not a `ControlProperties`: a CanvasLayer is a Node.
    const props = solveNode.node.properties;
    if (props.visible === false)
        return null;
    // The scroll and the cut ancestor chain are the world walk's half (`Component.tsx`).
    // The shared `<CanvasLayerScope>` keeps this canvas in step with the CanvasLayer painter.
    return _jsx(CanvasLayerScope, { node: solveNode.node, children: children });
}
//# sourceMappingURL=CanvasScope.js.map